import { AppAPI, } from '@moderepo/mode-apis';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var HomeSmartModulesActionType;
(function (HomeSmartModulesActionType) {
    HomeSmartModulesActionType["SET_HOME_SMART_MODULES"] = "set home smart modules";
    HomeSmartModulesActionType["SET_HOME_SMART_MODULE"] = "set home smart module";
})(HomeSmartModulesActionType || (HomeSmartModulesActionType = {}));
export const setHomeSmartModules = (homeId, modules) => {
    return {
        type: HomeSmartModulesActionType.SET_HOME_SMART_MODULES,
        homeId,
        modules,
    };
};
/**
 * Fetch a home smart modules
 * @param homeId - The home id
 * @param suppressError - Whether or not to throw error when it occur, default is false, throw error. This API will throw an error when a project
 *                        does not have SmartModule setup which might not a big deal in some cases. Sometime we can just treat it as an EMPTY
 *                        smart modules list instead. So if the caller doesn't want to throw error, it can pass 'true' to suppress errors and provide
 *                        default value to return if error occurs
 * @param defaultValue - The value to return if error occurs and suppressError is true..
 */
export const fetchAllHomeSmartModules = (homeId, suppressError = false, defaultValue = []) => {
    return async (dataDispatch) => {
        try {
            const smartModules = await AppAPI.getInstance().getAllHomeSmartModules(homeId);
            await dataDispatch(setHomeSmartModules(homeId, smartModules));
        }
        catch (error) {
            if (suppressError) {
                // If suppressError, use the defaultValue as result.
                await dataDispatch(setHomeSmartModules(homeId, defaultValue));
            }
            throw error;
        }
    };
};
